import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";

import { shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import DMAPA3Chart from "../../Charts/DMAPA3Chart";
import * as DMConst from "../../NonComponents/DMConst";

class DMAPA3IncrCovForm extends React.Component {
    static propTypes = {
        finalYear: PropTypes.number,
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        selectedSNU_CurrID: PropTypes.number,
    };

    static defaultProps = {
        navComboBoxHeight: 35,
        results: {},
        selectedSNU_CurrID: 1,
    };

    constructor(props) {
        super(props);

        this.state = {
            finalYear: DMConst.lastYearProgData,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;

            const state = this.state;
            const finalYear = state.finalYear;

            const chart = (
                <DMAPA3Chart
                    finalYear={finalYear}
                    navComboBoxHeight={navComboBoxHeight}
                    results={results}
                    selectedSNU_CurrID={selectedSNU_CurrID}
                />
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: 30,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear; t++) {
                year1DIntArray.push(t.toString());
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {finalYearLabel}
                    {finalYearComboBox}
                </div>
            );

            const configDiv = <div style={Theme.configDivStyle}>{configLeftDiv}</div>;

            return (
                <div>
                    {chart}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMAPA3IncrCovFormDiv"}
                    key={"DMAPA3IncrCovFormDiv"}
                >
                    <h3 key={"DMAPA3IncrCovFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMAPA3IncrCovForm;
